import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const messagesAdapter = createEntityAdapter({
    sortComparer: (a, b) => (a.completed === b.completed) ? 0 : a.completed ? 1 : -1
})

const initialState = messagesAdapter.getInitialState()

export const messagesApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getMessages: builder.query({
            query: () => ({
                url: '/api/messages',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedMessages = responseData.map(message => {
                    message.id = message._id
                    return message
                });
                return messagesAdapter.setAll(initialState, loadedMessages)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Message', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Message', id }))
                    ]
                } else return [{ type: 'Message', id: 'LIST' }]
            }
        }),
        getMessagesForStudent: builder.query({
            query: () => ({
                url: '/api/messages/students',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            providesTags: (result, error, arg) => {
                //console.log("arg", arg)
                return [{ type: 'StudentMessages', id: "LIST" }]
            }
                       
        }),
        addNewMessage: builder.mutation({
            query: initialMessage => ({
                url: '/api/messages',
                method: 'POST',
                body: {
                    ...initialMessage,
                }
            }),
            invalidatesTags: [
                { type: 'Message', id: "LIST" }
            ]
        }),
        updateMessage: builder.mutation({
            query: initialMessage => ({
                url: '/api/messages',
                method: 'PATCH',
                body: {
                    ...initialMessage,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Message', id: arg.id }
            ]
        }),
        deleteMessage: builder.mutation({
            query: ({ id }) => ({
                url: `/api/messages`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Message', id: arg.id }
            ]
        }),
        addComment: builder.mutation({
            query: initialMessage => ({
                url: '/api/messages/comments',
                method: 'POST',
                body: {
                    ...initialMessage,
                }
            }),
            invalidatesTags: [
                { type: 'StudentMessages', id: "LIST" }
            ]
        }),
        markCommentsComplete: builder.mutation({
            query: initialMessage => ({
                url: '/api/messages/comments-complete',
                method: 'POST',
                body: {
                    ...initialMessage,
                }
            }),
            invalidatesTags: [
                { type: 'Message', id: "LIST" }
            ]
        }),
    }),
})

export const {
    useGetMessagesQuery,
    useGetMessagesForStudentQuery,
    useAddNewMessageMutation,
    useUpdateMessageMutation,
    useDeleteMessageMutation,
    useAddCommentMutation,
    useMarkCommentsCompleteMutation
} = messagesApiSlice

// returns the query result object
export const selectMessagesResult = messagesApiSlice.endpoints.getMessages.select()

// creates memoized selector
const selectMessagesData = createSelector(
    selectMessagesResult,
    messagesResult => messagesResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllMessages,
    selectById: selectMessageById,
    selectIds: selectMessageIds
    // Pass in a selector that returns the messages slice of state
} = messagesAdapter.getSelectors(state => selectMessagesData(state) ?? initialState)